import ReelsToBuy, { MediaItem } from "@/components/ReelsToBuy";
import { useSEO } from "@/hooks/useSEO";
import { useEffect } from "react";
import { BRAND_SITE_URL } from "@/lib/brandConfig";

/**
 * Pack3 Page - Example pack with only videos (vertical scroll style)
 *
 * Features:
 * - Shows first 3 videos for free (preview)
 * - Vertical scroll navigation (swipe up/down)
 * - After 3rd video, shows "Buy" button at bottom
 */
const Pack3 = () => {
  // SEO configuration
  useSEO({
    title: "Pack Premium #3 - Videos Exclusivos",
    description: "Accede a videos exclusivos premium",
    keywords: "pack, videos, premium, exclusivo",
    ogImage: `${BRAND_SITE_URL}/og-pack3.jpg`,
    ogTitle: "Pack Premium #3",
    ogDescription: "Videos exclusivos premium",
    type: "website",
    robots: "noindex, nofollow",
  });

  // Disable body scroll when on pack page
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalWidth = document.body.style.width;
    const originalHeight = document.body.style.height;
    const originalTouchAction = document.body.style.touchAction;

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.height = "100%";
    document.body.style.touchAction = "none";

    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.width = originalWidth;
      document.body.style.height = originalHeight;
      document.body.style.touchAction = originalTouchAction;
      document.documentElement.style.overflow = "";
    };
  }, []);

  // Define your pack content here - ONLY VIDEOS
  // Replace with your actual Mux playback IDs
  const packItems: MediaItem[] = [
    {
      type: "video",
      src: "YOUR_MUX_PLAYBACK_ID_1", // Replace with actual Mux playback ID
    },
    {
      type: "video",
      src: "YOUR_MUX_PLAYBACK_ID_2",
    },
    {
      type: "video",
      src: "YOUR_MUX_PLAYBACK_ID_3",
    },
    // More videos (will be locked behind purchase)
    {
      type: "video",
      src: "YOUR_MUX_PLAYBACK_ID_4",
    },
    {
      type: "video",
      src: "YOUR_MUX_PLAYBACK_ID_5",
    },
    {
      type: "video",
      src: "YOUR_MUX_PLAYBACK_ID_6",
    },
  ];

  const handlePurchase = () => {
    if (import.meta.env.DEV) {
      console.log("Purchase clicked for Pack3");
    }
    // Add your purchase logic here
  };

  return (
    <ReelsToBuy
      items={packItems}
      maxFreeItems={3}
      price="$19.99"
      packName="Pack Premium #3 - Videos"
      purchaseUrl="/checkout/pack3"
      onPurchaseClick={handlePurchase}
    />
  );
};

export default Pack3;
